import { useState } from "react";
import { useTranslation } from "react-i18next";
import firstStepImage from "@monorepo/assets/src/img/gsmVoucherInstructions/first-step.png";
import secondStepImage from "@monorepo/assets/src/img/gsmVoucherInstructions/second-step.png";
import thirdStepImage from "@monorepo/assets/src/img/gsmVoucherInstructions/third-step.png";
import { ScrollableContainer, StyledPageWrapper, Title } from "@monorepo/components";
import theme from "@monorepo/styles/theme";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { Box, IconButton, Step, StepContent, StepLabel, Stepper, styled, Typography } from "@mui/material";

import { PageWrapper } from "components/Services/ServicesPage";

const StyledStepper = styled(Stepper)(() => ({
  [theme.breakpoints.up("md")]: {
    minWidth: "100%",
  },
  [theme.breakpoints.up("xl")]: {
    minWidth: "800px",
  },
  [theme.breakpoints.up("xxl")]: {
    minWidth: "850px",
  },
}));

const HowToUseGsmVoucher = () => {
  const { t } = useTranslation();
  const [activeStep, setActiveStep] = useState(0);

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const steps = [
    {
      key: 0,
      image: firstStepImage,
      description: t("gsmVoucherServices.wizard.step_1"),
    },
    {
      key: 1,
      image: secondStepImage,
      description: t("gsmVoucherServices.wizard.step_2"),
    },
    {
      key: 2,
      image: thirdStepImage,
      description: t("gsmVoucherServices.wizard.step_3"),
    },
  ];

  return (
    <StyledPageWrapper>
      <PageWrapper>
        <Title>{t("gsmVoucherServices.how_to_use_code")}</Title>
        <ScrollableContainer>
          <StyledStepper sx={{ width: "400px" }} activeStep={activeStep} orientation="horizontal">
            {steps.map((step) => (
              <Step key={step.key}>
                <StepLabel />
              </Step>
            ))}
          </StyledStepper>
          {steps
            .filter((step) => step.key === activeStep)
            .map((step) => {
              return (
                <Step key={step.key}>
                  <StepContent sx={{ borderLeft: "none" }}>
                    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                      <Typography mt={2} mb={3} textAlign="center" component="p" variant="h6">
                        {step.description}
                      </Typography>
                      <Box
                        component="img"
                        sx={{ maxWidth: step.key === 2 ? "450px" : "250px" }}
                        src={step.image}
                        alt="step instruction"
                      />
                      <Box sx={{ mt: 2, display: "flex", columnGap: 1 }}>
                        {step.key !== 0 && (
                          <IconButton
                            aria-label={t("common.back")}
                            sx={{
                              width: theme.spacing(7),
                              height: theme.spacing(7),
                              display: "flex",
                              justifyItems: "center",
                            }}
                            type="button"
                            onClick={handleBack}
                          >
                            <ArrowBackIosIcon
                              fontSize="large"
                              viewBox="-5 0 25 25"
                              sx={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                height: "35px",
                                width: "35px",
                                fill: theme.palette.primary.main,
                              }}
                            />
                          </IconButton>
                        )}

                        {step.key !== 2 && (
                          <IconButton
                            aria-label={t("common.back")}
                            sx={{
                              width: theme.spacing(7),
                              height: theme.spacing(7),
                              display: "flex",
                              justifyItems: "center",
                            }}
                            type="button"
                            onClick={handleNext}
                          >
                            <ArrowForwardIosIcon
                              fontSize="large"
                              viewBox="-2 0 25 25"
                              sx={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                height: "35px",
                                width: "35px",
                                fill: theme.palette.primary.main,
                              }}
                            />
                          </IconButton>
                        )}
                      </Box>
                    </Box>
                  </StepContent>
                </Step>
              );
            })}
        </ScrollableContainer>
      </PageWrapper>
    </StyledPageWrapper>
  );
};

export default HowToUseGsmVoucher;
